import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u199988525/domains/glanzcrm.com/hbuilds/source/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u199988525/domains/glanzcrm.com/hbuilds/source/src/components/ui/AppIcon.tsx");
